import { configureStore, createAction, combineReducers } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import dashboardReducer from "../features/Dashboard/Slices/dashboardSlice";
import alumnosReducer from "../features/Dashboard/Slices/alumnosSlice";
import userReducer from "../features/Dashboard/Slices/userSlice";
import globalFlagsReducer from "../features/Dashboard/Slices/globalFlagsSlice";

export const appLogout = createAction('app/logout');

const appReducer = combineReducers({
  dashboard: dashboardReducer,
  alumnos: alumnosReducer,
  user: userReducer,
  globalFlags: globalFlagsReducer,
});

type AppReducerState = ReturnType<typeof appReducer>;

const rootReducer = (state: AppReducerState | undefined, action: any): AppReducerState => {
  if (action.type === appLogout.type) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer, 
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;